import { ComponentInstance, onBeforeMount } from "@vue/composition-api";

const useGetTableLibs = (root: ComponentInstance): void => {
  const store = root.$store;

  onBeforeMount(() => {
    store.dispatch("informationSecurityJournal/getEventCodes");
    store.dispatch("informationSecurityJournal/getObjectTypes");
  });
};

export default useGetTableLibs;
